'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TranslatedRequirementSetTitle = function TranslatedRequirementSetTitle(_ref) {
    var requirementSet = _ref.requirementSet;

    switch (requirementSet.code) {
        case 'ACKNOWLEDGEMENTS':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.acknowledgements',
                    defaultMessage: 'Acknowledgements' });
            }
        case 'CONTACT_INFORMATION':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.contactInformation',
                    defaultMessage: 'Contact Information' });
            }
        case 'EMERGENCY_CONTACT_INFORMATION':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.emergencyContactInformation',
                    defaultMessage: 'Emergency Contact Information' });
            }
        case 'FLIGHT_INFORMATION':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.flightInformation',
                    defaultMessage: 'Flight Information' });
            }
        case 'INSURANCE_INFORMATION':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.insuranceInformation',
                    defaultMessage: 'Insurance Information' });
            }
        case 'LIABILITY_WAIVER':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.liabilityWaiver',
                    defaultMessage: 'Liability Waiver' });
            }
        case 'MEDICAL_INFORMATION':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.medicalInformation',
                    defaultMessage: 'Medical Information' });
            }
        case 'TRAVEL_READY':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.travelReady',
                    defaultMessage: 'Travel Ready' });
            }
        case 'PARTICIPATION_WAIVER':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.participationWaiver',
                    defaultMessage: 'Participation Waiver' });
            }
        case 'PASSPORT_INFORMATION':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.passportInformation',
                    defaultMessage: 'Passport Information' });
            }
        case 'PERSONAL_INFORMATION':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.personalInformation',
                    defaultMessage: 'Personal Information' });
            }
        case 'TRANSFER_INFORMATION':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.transferInformation',
                    defaultMessage: 'Transfer Information' });
            }
        case 'TRAVEL_DOCUMENTS':
            {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'requirementSetNames.travelDocuments',
                    defaultMessage: 'Travel Documents' });
            }
        default:
            {
                return _react2.default.createElement(
                    'span',
                    null,
                    requirementSet.name
                );
            }
    }
};
TranslatedRequirementSetTitle.propTypes = {
    requirementSet: _propTypes2.default.object.isRequired
};

exports.default = TranslatedRequirementSetTitle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/TranslatedRequirementSetTitle.js
// module id = 1351
// module chunks = 0